import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface FloatingReactionProps {
  emoji: string;
  trigger: number;
}

interface Particle {
  id: number;
  x: number;
  rotate: number;
  scale: number;
  duration: number;
}

export const FloatingReaction = ({
  emoji,
  trigger,
}: FloatingReactionProps) => {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    if (!trigger) return;

    const ids: number[] = [];

    const burst: Particle[] = Array.from({ length: 5 }).map((_, i) => {
      const id = Date.now() + i;

      ids.push(id);

      return {
        id,
        x: (Math.random() - 0.5) * 140,
        rotate: (Math.random() - 0.5) * 80,
        scale: 0.8 + Math.random() * 0.8,
        duration: 0.8 + Math.random() * 0.5,
      };
    });

    setParticles((prev) => [...prev, ...burst]);

    const timer = setTimeout(() => {
      setParticles((prev) =>
        prev.filter((p) => !ids.includes(p.id)),
      );
    }, 1500);

    return () => clearTimeout(timer);
  }, [trigger]);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-visible">
      <AnimatePresence>
        {particles.map((particle) => (
          <motion.div
            key={particle.id}
            initial={{
              opacity: 1,
              x: 0,
              y: 0,
              scale: particle.scale,
              rotate: particle.rotate,
            }}
            animate={{
              opacity: 0,
              x: particle.x,
              y: -160,
              scale: particle.scale + 0.5,
            }}
            exit={{ opacity: 0 }}
            transition={{
              duration: particle.duration,
              ease: 'easeOut',
            }}
            className="absolute bottom-4 left-1/2 text-3xl"
          >
            {emoji}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};